import { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import logo from '../../Assets/Logo/Sridhar_Dental-logo.webp';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  const mobileMenuRef = useRef(null);
  const location = useLocation();
// Add these at the top of your Header component
const [treatmentsOpen, setTreatmentsOpen] = useState(false);
const dropdownRef = useRef(null);
const toggleButtonRef = useRef(null);


// Add this useEffect to close dropdown when clicking outside
// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setTreatmentsOpen(false);
//     }
//   };

//   document.addEventListener('mousedown', handleClickOutside);
//   return () => document.removeEventListener('mousedown', handleClickOutside);
// }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
    setTreatmentsOpen(false);
  }, [location.pathname]);

  // Scroll handler with throttle
  useEffect(() => {
    let timeoutId;
    const handleScroll = () => {
      if (timeoutId) return;
      timeoutId = setTimeout(() => {
        setIsScrolled(window.scrollY > 40);
        timeoutId = null;
      }, 80);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  // Close mobile menu on outside click / ESC
  useEffect(() => {
    const handleClickOutside = (e) => {
  if (
    isOpen &&
    mobileMenuRef.current &&
    !mobileMenuRef.current.contains(e.target) &&
    toggleButtonRef.current &&
    !toggleButtonRef.current.contains(e.target)
  ) {
    setIsOpen(false);
  }
};



    const handleEsc = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEsc);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen]);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const navLinkClass = ({ isActive }) => `
    relative font-medium transition-all duration-300
    ${isActive 
      ? 'text-blue-600 font-semibold after:w-full' 
      : 'text-gray-800 hover:text-blue-600 after:w-0 hover:after:w-full'}
    after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:bg-blue-600
    after:transition-all after:duration-300 after:ease-out
  `;

  const mobileNavClass = ({ isActive }) => `
    block py-3 px-4 rounded-lg transition
    ${isActive 
      ? 'bg-blue-50 text-blue-700 font-semibold' 
      : 'text-gray-800 hover:bg-gray-50 active:bg-gray-100'}
  `;

  return (
    <>
      {/* Top bar – hidden on mobile */}
      {/* <div className="hidden md:block bg-gray-50/80 backdrop-blur-sm text-gray-700 text-sm py-2 border-b border-gray-200/70 sticky top-0 z-50">
        <div className="container mx-auto px-6 flex justify-between items-center">
          <div className="flex items-center gap-6">
            <a href="tel:+919490948081" className="flex items-center hover:text-blue-600 transition">
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              +91 9490 948 081
            </a>
            <a href="mailto:info@sridhardental.com" className="flex items-center hover:text-blue-600 transition">
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              dr.sridhardental@gmail.com
            </a>
          </div>
          <div className="flex items-center">
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6z" />
              <path d="M10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
            </svg>
            Mon–Sat: 9 AM – 9 PM
          </div>
        </div>
      </div> */}

      {/* Main Header */}
      <header
        className={`sticky top-0 w-full z-50 transition-all duration-500 ease-out
          ${isScrolled 
            ? 'bg-white/95 backdrop-blur-md shadow-lg' 
            : 'bg-white/95 backdrop-blur-sm '}
          ${prefersReducedMotion ? '!transition-none' : ''}`}
      >
        <div className="container mx-auto px-5 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          {/* Logo */}
          <Link
  to="/"
  className="flex-shrink-0"
  onClick={(e) => {
    if (location.pathname === "/") {
      e.preventDefault();
    }

    // Force scroll on both possible containers
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);
  }}
>
            <img 
              src={logo} 
              alt="Sridhar Dental Clinic Logo" 
              className="h-11 sm:h-12 md:h-14 object-contain" 
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8 xl:gap-10"> 
            <NavLink to="/" className={navLinkClass} end>Home</NavLink>
            <NavLink to="/about" className={navLinkClass}>About Us</NavLink>
            <NavLink to="/services" className={navLinkClass}>Services</NavLink>

            {/* Treatments dropdown */}
        

{/* <div className="relative" ref={dropdownRef}>
  <button
    type="button"
    onClick={() => setTreatmentsOpen(!treatmentsOpen)}
    className="flex items-center gap-1 font-medium text-gray-800 hover:text-blue-600 transition-colors focus:outline-none"
    aria-expanded={treatmentsOpen}
    aria-haspopup="true"
  >
    Treatments
    <svg
      className={`w-4 h-4 transition-transform duration-200 ${
        treatmentsOpen ? 'rotate-180' : ''
      }`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <div
    className={`absolute left-0 top-full mt-2 w-72 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50
      transition-all duration-200 origin-top
      ${
        treatmentsOpen
          ? 'opacity-100 translate-y-0 visible pointer-events-auto'
          : 'opacity-0 -translate-y-2 invisible pointer-events-none'
      }`}
  >
    <div className="py-2 divide-y divide-gray-100">
      <NavLink
        to="/treatments/pediatric-dentistry"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Pediatric Dentistry
      </NavLink>

      <NavLink
        to="/treatments/gum-care"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Gum Care
      </NavLink>

      <NavLink
        to="/treatments/endodontic"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Endodontics
      </NavLink>

      <NavLink
        to="/treatments/laser-dentistry"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Laser Dentistry
      </NavLink>

      <NavLink
        to="/treatments/crowns-and-bridges"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Crowns & Bridges
      </NavLink>

      <NavLink
        to="/treatments/dentures"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Dentures
      </NavLink>

      <NavLink
        to="/treatments/oral-maxillofacial-surgery"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Oral & Maxillofacial Surgery
      </NavLink>

      <NavLink
        to="/treatments/dental-implants"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Dental Implants
      </NavLink>

      <NavLink
        to="/treatments/orthodontics"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Orthodontics / Braces
      </NavLink>

      <NavLink
        to="/treatments/cosmetic-dentistry"
        className={({ isActive }) =>
          `block px-5 py-3.5 text-gray-800 hover:bg-blue-50 hover:text-blue-700 transition-colors ${
            isActive ? 'bg-blue-50 text-blue-700 font-semibold' : ''
          }`
        }
        onClick={() => setTreatmentsOpen(false)}
      >
        Cosmetic Dentistry
      </NavLink>
    </div>
  </div>
</div> */}

           
                        <NavLink to="/blog" className={navLinkClass}>Our Blog</NavLink>
                                                <NavLink to="/gallery" className={navLinkClass}>Gallery</NavLink>
                                                 <NavLink to="/contact" className={navLinkClass}>Contact</NavLink>


          </nav>

          {/* CTA + Mobile toggle */}
          <div className="flex items-center gap-4">
            <Link
              to="/book-appointment"
              className="hidden md:inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-full font-medium transition shadow-sm hover:shadow-md"
            >
              Book Appointment
            </Link>

            <button
  ref={toggleButtonRef}
  type="button"
  className="lg:hidden text-gray-800 p-1 -mr-2"
  onClick={() => setIsOpen(prev => !prev)}
  aria-expanded={isOpen}
  aria-label="Toggle navigation menu"
>

              <svg className="w-9 h-9" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.2}
                  d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 8h16M4 16h16'}
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div
          ref={mobileMenuRef}
          className={`lg:hidden bg-white border-t transition-all duration-300 ease-out overflow-hidden
            ${isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}
        >
          <nav className="container mx-auto px-5 py-6 flex flex-col gap-3 text-base">
            <NavLink to="/" className={mobileNavClass} end onClick={() => setIsOpen(false)}>Home</NavLink>
            <NavLink to="/about" className={mobileNavClass} onClick={() => setIsOpen(false)}>About Us</NavLink>
            <NavLink to="/services" className={mobileNavClass} onClick={() => setIsOpen(false)}>Services</NavLink>

            {/* Mobile Treatments accordion */}
            {/* <div>
              <button
                type="button"
                onClick={() => setTreatmentsOpen(!treatmentsOpen)}
                className={`w-full flex justify-between items-center py-3 px-4 rounded-lg font-medium transition
                  ${treatmentsOpen ? 'bg-blue-50 text-blue-700' : 'text-gray-800 hover:bg-gray-50'}`}
              >
                Treatments
                <svg className={`w-5 h-5 transition-transform ${treatmentsOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${treatmentsOpen ? 'max-h-40' : 'max-h-0'}`}>
                <div className="pl-4 pt-1 pb-3 flex flex-col gap-1">
                  <NavLink 
                    to="/treatments/implants" 
                    className="block py-2.5 px-4 rounded hover:bg-blue-50 text-gray-700 hover:text-blue-700"
                    onClick={() => setIsOpen(false)}
                  >
                    Dental Implants
                  </NavLink>
                  <NavLink 
                    to="/treatments/orthodontics" 
                    className="block py-2.5 px-4 rounded hover:bg-blue-50 text-gray-700 hover:text-blue-700"
                    onClick={() => setIsOpen(false)}
                  >
                    Orthodontics / Braces
                  </NavLink>
                </div>
              </div>
            </div> */}

            <NavLink to="/blog" className={mobileNavClass} onClick={() => setIsOpen(false)}>Our Blog</NavLink>
            <NavLink to="/gallery" className={mobileNavClass} onClick={() => setIsOpen(false)}>Gallery</NavLink>
            <NavLink to="/contact" className={mobileNavClass} onClick={() => setIsOpen(false)}>Contact</NavLink>


            <Link
              to="/book-appointment"
              className="mt-4 bg-blue-600 hover:bg-blue-700 text-white py-3.5 px-6 rounded-xl font-medium text-center shadow-sm"
              onClick={() => setIsOpen(false)}
            >
              Book Appointment
            </Link>
          </nav>
        </div>
      </header>

      {/* Spacer when header becomes fixed */}
      {/* <div className={`h-20 md:h-24 ${isScrolled ? '' : 'md:h-32'}`} /> */}
    </>
  );
};

export default Header;